import { css } from 'styled-components';

export const WidthTransition = css`
  transition:
    max-width 0.1s ease-in-out,
    width 0.1s ease-in-out;
`;
